var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import gsap from 'gsap';
import parse from 'html-react-parser';
import SquareBackgroundClipPath from './SquareBackgroundClipPath';
export default function BackgroundImageShapeSection(_a) {
    var imageAssets = _a.imageAssets, firstLeafRowRef = _a.firstLeafRowRef, secondLeafRowRef = _a.secondLeafRowRef, mainTitle = _a.mainTitle, mainParagraph = _a.mainParagraph;
    var isShapeDirectionRight = function (order) {
        switch (order) {
            case 1:
            case 4:
                return true;
            case 2:
            case 3:
                return false;
            default:
                return false;
        }
    };
    var positionClasses = function (order) {
        switch (order) {
            case 1:
                return "relative lg:-top-11 md:-top-11 -top-7";
            case 4:
                return 'true';
            case 2:
            case 3:
                return 'false';
            default:
                return 'false';
        }
    };
    var renderBackgroundAssets = function (arrayAssets) {
        return arrayAssets
            .sort(function (a, b) { return a.order - b.order; })
            .map(function (dataProps, index) { return (_jsx(SquareBackgroundClipPath, { positionClasses: positionClasses(dataProps.order), index: index, isDirectionRight: isShapeDirectionRight(dataProps.order), imageObject: dataProps, widthClasses: "w-96" }, dataProps.src + dataProps.order)); });
    };
    var firstTwoBackgrounds = imageAssets.slice(0, 2);
    var lastTwoBackgrounds = imageAssets.slice(-2, 4);
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.two-column-background-shape__image-shapes',
                start: 'top center',
            },
        });
        tl.fromTo([
            '.two-column-background-shape__title',
            '.two-column-background-shape__para',
        ], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    return (_jsxs("div", __assign({ className: "two-column-background-shape__image-shapes relative mt-24  block md:mt-16 lg:mt-0" }, { children: [_jsxs("div", __assign({ className: "justify-around lg:flex" }, { children: [_jsxs("div", __assign({ className: "two-column-background-shape__content block px-6 pb-14 text-enblue-900 md:block md:px-24 md:pb-20 lg:px-20 lg:order-2 lg:w-1/2 lg:pb-0" }, { children: [_jsx("h2", __assign({ className: "mb-6 flex items-start text-left font-normal md:mb-4 md:w-11/12 lg:mb-8 two-column-background-shape__title" }, { children: mainTitle }), void 0),
                            mainParagraph && (_jsx("p", __assign({ className: "text-sm font-light leading-6 md:text-base md:leading-6 lg:text-lg lg:leading-6 max-h-52 overflow-y-auto two-column-background-shape__para" }, { children: parse(mainParagraph) }), void 0))] }), void 0),
                    _jsx("div", __assign({ className: "relative flex space-x-3.5 md:space-x-6  lg:order-1 lg:space-x-7 lg:pt-1.5", ref: firstLeafRowRef }, { children: renderBackgroundAssets(firstTwoBackgrounds) }), void 0)] }), void 0),
            _jsx("div", __assign({ className: "relative mt-3 flex justify-end space-x-3.5 md:mt-6 md:ml-56 md:space-x-7 lg:ml-16 lg:mt-8 lg:justify-center lg:space-x-6", ref: secondLeafRowRef }, { children: renderBackgroundAssets(lastTwoBackgrounds) }), void 0)] }), void 0));
}
